// Determine WebSocket protocol
// const isSecure = process.env.REACT_APP_WEBSOCKET_SECURE === "true";
// const wsProtocol = isSecure ? "wss" : "ws";

// Export configuration
export const API_URL = `${process.env.REACT_APP_API_URL}/api`;
export const STORAGE_URL = process.env.REACT_APP_STORAGE_URL;
export const WEBSOCKET_URL = `${process.env.REACT_APP_DOMAIN}:${process.env.REACT_APP_WEBSOCKET_PORT}/my-websocket`;
